"use strict";

exports.__esModule = true;
exports.getDefaultLocation = void 0;
var _types = require("@wix/ambassador-bookings-services-v2-service/types");
var _calculatePreferencesView = require("../../utils/calculatePreferencesView/calculatePreferencesView");
var _bookingsCalendarCatalogViewerMapper = require("@wix/bookings-calendar-catalog-viewer-mapper");
var _getQueryParams = require("../../utils/getQueryParams");
const getDefaultLocation = ({
  service,
  bookingsSettings,
  experiments,
  serviceOptionsAndVariants,
  openedBy,
  queryParams
}) => {
  var _service$locations;
  const isBookFlowSettingsEnabled = (0, _bookingsCalendarCatalogViewerMapper.isBookFlowSettingsEnabled)({
    experiments,
    bookingsSettings
  });
  const preferencesView = (0, _calculatePreferencesView.calculatePreferencesViewForAppointment)({
    service,
    bookingsSettings,
    serviceOptionsAndVariants,
    openedBy,
    queryParams
  });
  const locationDisplayOnCalendar = isBookFlowSettingsEnabled && preferencesView[_calculatePreferencesView.PreferenceType.LOCATION] === _calculatePreferencesView.DisplayTarget.CALENDAR;
  const hasNoLocations = !((_service$locations = service.locations) != null && _service$locations.length);
  if (locationDisplayOnCalendar || hasNoLocations) {
    return;
  }
  const locationFromUrl = (0, _getQueryParams.getLocationFromUrl)(queryParams);
  if (locationFromUrl) {
    var _service$locations2;
    const matchingLocation = (_service$locations2 = service.locations) == null ? void 0 : _service$locations2.find(location => {
      var _location$business;
      return ((_location$business = location.business) == null ? void 0 : _location$business.id) === locationFromUrl;
    });
    if (matchingLocation) {
      return {
        type: _types.LocationType.BUSINESS,
        value: locationFromUrl
      };
    }
  }
  const firstLocation = service.locations[0];
  const locationType = firstLocation.type;
  if (locationType === _types.LocationType.BUSINESS) {
    var _firstLocation$busine;
    return {
      type: locationType,
      value: (_firstLocation$busine = firstLocation.business) == null ? void 0 : _firstLocation$busine.id
    };
  } else if (locationType === _types.LocationType.CUSTOM) {
    var _firstLocation$custom;
    return {
      type: locationType,
      value: (_firstLocation$custom = firstLocation.custom) == null || (_firstLocation$custom = _firstLocation$custom.address) == null ? void 0 : _firstLocation$custom.formattedAddress
    };
  }
  return {
    type: _types.LocationType.CUSTOMER,
    value: ''
  };
};
exports.getDefaultLocation = getDefaultLocation;
//# sourceMappingURL=getDefaultLocation.js.map